import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import projects from './projects/projects';
import './Home.css';

// Load Satoshi font from Fontshare
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://api.fontshare.com/v2/css?f[]=satoshi@400,700&display=swap';
fontLink.id = 'satoshi-font-link';
if (!document.getElementById('satoshi-font-link')) {
  document.head.appendChild(fontLink);
}

document.body.style.fontFamily = 'Satoshi, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica Neue, Arial, sans-serif';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-root">
      <div className="project-grid">
        {projects.map((project, idx) => (
          <motion.div
            className="project-box"
            key={project.id}
            onClick={() => navigate(`/project/${project.id}`)}
            style={{ background: project.bg || '#e3e3e3' }}
          >
            <img src={project.image} alt={project.name} className="project-img" />
            <div className="project-overlay">
              <div className="project-content">
                <span className="project-title">{project.name}</span>
                <span className="project-description">{project.description}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Home; 